import { convertCentsToDollars } from '@melio/platform-utils';

import { FeeCatalog } from './types';

export const convertFeeCatalogEntryCentsToDollars = (data: FeeCatalog) =>
  data.valueType === 'fixed' ? convertCentsToDollars(data, ['value']) : data;

export const convertFeeCatalogsCentsToDollars = (data: FeeCatalog[]) => data.map(convertFeeCatalogEntryCentsToDollars);
